import React from 'react'
import styled from 'styled-components'
import { useBalance } from '../../hooks'
import { Currency } from '../../model'
import { CurrencySymbolImage } from './CurrencySymbolImage'
import { InputItem } from './InputItem'
import { usePairSelectModal } from '../../providers'

interface Props {
  label: string
  currency: Currency
  rate: string
  value: string
  disabled?: boolean
  onValueChange: (value: string) => void
  onMax: () => void
}

export function CurrencyInputItem({ label, currency, rate, value, disabled, onValueChange, onMax }: Props) {
  const balance = useBalance(currency)
  const { togglePairSelectModal } = usePairSelectModal()

  return (
    <InputItem
      label={label}
      symbol={currency.symbol}
      rate={rate}
      value={value}
      balance={balance ? balance.formatWithSymbol() : '-'}
      onValueChange={onValueChange}
      onMax={onMax}
      disabled={disabled}
    >
      <CurrencySymbolClickable onClick={togglePairSelectModal}>
        <CurrencySymbolImageStyled symbol={currency.symbol} />
        {currency.symbol}
      </CurrencySymbolClickable>
    </InputItem>
  )
}
const CurrencySymbolClickable = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

const CurrencySymbolImageStyled = styled(CurrencySymbolImage)`
  margin-right: 5px;
`
